import React from "react";
import styles from "./styles.module.scss";
import { cls } from "app/utils";
import { useTranslation } from "react-i18next";

interface IProps {
  product: any;
  enabledIntegration: boolean;
  className?: string;
}

export const ProductTypeLabel = ({
  product,
  enabledIntegration,
  className,
}: IProps) => {
  const { t } = useTranslation();
  // Only gray out online-only products when Stripe is disabled
  const requiresStripe = product.collectType === "online";
  const isActive = product.enabled && (enabledIntegration || !requiresStripe);

  const isProduct = product?.productType === "product";

  const colorClass = isActive
    ? isProduct
      ? styles.product_color
      : styles.subscription_color
    : styles.inactive_color;

  const labelClass = isProduct
    ? styles.product_label
    : styles.subscription_label;
  const text = isProduct ? t("PACKAGE") : t("SUBSCRIPTION");

  return <span className={cls(colorClass, labelClass, className)}>{text}</span>;
};
